
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot",
      function () {
        return require("private-next-pages/forgot.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot"])
      });
    }
  